import { render, staticRenderFns } from "./MetadataEditor.vue?vue&type=template&id=b275f940&"
import script from "./MetadataEditor.vue?vue&type=script&lang=js&"
export * from "./MetadataEditor.vue?vue&type=script&lang=js&"
import style0 from "./MetadataEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports